import { ContentItem } from '@kerfjs/ui/content-item';
import { EmptyState } from '@kerfjs/ui/empty-state';
import { List } from '@kerfjs/ui/list';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';
import { Bot } from 'lucide';

import type { BackgroundDocT, FactT } from '../../../data/api.js';
import { sourceLabel } from './library-fact-source.js';

export function LibraryFacts({
  facts,
  docs,
  query = '',
}: {
  facts: readonly FactT[];
  docs: readonly BackgroundDocT[];
  query?: string;
}): SafeHtml {
  if (facts.length === 0)
    return (
      <EmptyState
        title={query.trim() === '' ? 'No facts yet' : 'No matching facts'}
        detail={query.trim() === '' ? 'Choose New Fact… to add one.' : 'Try another search.'}
      />
    );
  return (
    <List gap="xs">
      {facts.map((fact) => (
        <ContentItem
          interactive
          action="lib-edit-fact"
          itemId={fact.id}
          frame="framed"
          title={fact.text}
          rootAttributes={{ 'data-key': fact.id }}
        >
          <span class="library-fact-preview">{fact.text}</span>
          <Text variant="span" tone="quiet" size="compact" className="library-fact-source">
            {fact.sourceKind === 'ai' || fact.sourceDocumentId !== null ? (
              <LucideIcon icon={Bot} name="AI" size="s" />
            ) : null}
            {sourceLabel(fact, docs)}
          </Text>
        </ContentItem>
      ))}
    </List>
  );
}
